import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Amplify } from 'aws-amplify';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.useProductionMode) {
    enableProdMode();
}

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: environment.userPoolId,
            userPoolClientId: environment.cognitoClientId,
            identityPoolId: environment.identityPoolId
        }
    }
});

document.addEventListener('DOMContentLoaded', () => {
    platformBrowserDynamic()
        .bootstrapModule(AppModule)
        .catch(err => {
            // eslint-disable-next-line no-console
            console.log(err);
        });
});
